import { render, staticRenderFns } from "./AcademySelectPlus.vue?vue&type=template&id=633b6d1a"
import script from "./AcademySelectPlus.vue?vue&type=script&lang=js"
export * from "./AcademySelectPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports